import { createFileRoute } from '@tanstack/react-router'

import { RegisterPage } from '@/features/auth/components/RegisterPage'
import { redirectAuthenticated } from '@/features/auth/route-access'

export const Route = createFileRoute('/register')({
  beforeLoad: redirectAuthenticated,
  component: RegisterPage,
})
